import { Link } from "react-router-dom";
import Button from "../Button/Button";
import InputField from "../InputField/InputField";
import "./LoginMirakl.scss";
import { useEffect, useState } from "react";
import { getLoginMiraklSsoQueryParametersQuery } from "./queries";
import { useLazyQuery } from "@apollo/client";
import useCookie from "hooks/useCookie";
import LoginMiraklAuth from "./LoginMiraklAuth";
import { displayError } from "utils/displayNotification";

interface MiraklLoginResponse {
  clientId: string;
  tenant: string;
  audience: string;
  state: string;
  url: string;
};

const LoginMirakl = () => {
  const [showLoginMiraklAuth, setShowLoginMiraklAuth] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [marketplaceId, setMarketplaceId] = useState("");
  const [, setStateCookie] = useCookie("LoginState");

  useEffect(() => {
    marketplaceId.length > 0 ? setButtonDisabled(false) : setButtonDisabled(true)
  }, [marketplaceId]);

  const [loginMirakl] = useLazyQuery<
    { getLoginMiraklSsoQueryParameters: MiraklLoginResponse },
    { marketplaceId: string }
  >(getLoginMiraklSsoQueryParametersQuery, {
    onCompleted: (data) => {
      setStateCookie(data.getLoginMiraklSsoQueryParameters.state, 7);
      const redirectUri = `${window.location.origin}/login/auth/mirakl?tenant=${data.getLoginMiraklSsoQueryParameters.tenant}&response_type=code&audience=${data.getLoginMiraklSsoQueryParameters.audience}&state=${data.getLoginMiraklSsoQueryParameters.state}`;
      window.location.href = `${data.getLoginMiraklSsoQueryParameters.url}/authorize?client_id=${data.getLoginMiraklSsoQueryParameters.clientId}&scope=openid&redirect_uri=${redirectUri}`;
    },
    onError: (e) => {
      displayError("Marketplace ID is invalid");
      setTimeout(() => {
        setButtonDisabled(false);
      }, 1500);
    },
  });
  const handleShowLoginMiraklAuth = (showLoginMiraklAuth: boolean) => {
    setShowLoginMiraklAuth(showLoginMiraklAuth);
  }

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    loginMirakl({ variables: { marketplaceId } });
  };

  return (
    <div>
      {!showLoginMiraklAuth && <form className="login__form" onSubmit={handleFormSubmit}>
        <InputField
          type="text"
          required={true}
          autoFocus={true}
          placeholder="Marketplace ID"
          icon={""}
          onChange={(e: any) => setMarketplaceId(e.target.value)}
          id="login-mirakl-input"
        />
        <div className="buttons-container">
          <div className="buttons-container__row">
            <Link to="/login">Go Back</Link>
          </div>
          <div className="buttons-container__row">
            <Button
              type="submit"
              className="button--primary button--block"
              content="Continue"
              icon={""}
              disabled={buttonDisabled}
              onClick={() => {
                loginMirakl({ variables: { marketplaceId } });
              }}
            />
          </div>
        </div>
      </form>}
      <LoginMiraklAuth
        handleShowLoginMiraklAuth={handleShowLoginMiraklAuth}
      />
    </div>

  );
};

export default LoginMirakl;
